export default __webpack_public_path__ + "static/media/success-big.0792ff39.svg";